import { useState } from 'react'
import { ButtonGroup, Dropdown, SplitButton } from 'react-bootstrap'
import '../assets/css/app.css'
import styles from '../css/styles.module.css'


function Selector_Component({ row, id, onSelect }) {


  let [status, setStatus] = useState([row.status])
  let classvalue = 'warning'
  if (row.status == 'Activated')
    classvalue = 'success'
  else if (row.status == 'Deactivated')
    classvalue = 'danger'
  else if (row.status == 'Pending')
    classvalue = 'warning'
  let [classs, setClasss] = useState(classvalue)

  return (
    <div key={`selector-${id}`} className='row'>
      <SplitButton
        as={ButtonGroup}
        key={row.id}
        id={`dropdown-variants`}
        variant={classs}
        className={styles.w_200}
        onSelect={e => onSelect(e, row.id, setStatus, setClasss)}
        title={status}
      >
        <Dropdown.Item className='btn-outline-primary'  eventKey="Pending">Pending accuont</Dropdown.Item>
        <Dropdown.Item className='btn-outline-primary' eventKey="Activated">Activate account</Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item className='btn-outline-primary' eventKey="Deactivated">Deactivate account</Dropdown.Item>
      </SplitButton>
    </div>
  )
}

export default Selector_Component
